import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "./signup.css";
import ppp from "../Images/Easytaxexperts_logo.png";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const Signup = () => {
  const [value, setValue] = useState({
    username: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
  });
  const [passwordStrength, setPasswordStrength] = useState("");
  const [terms, setTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleTermsChange = () => setTerms(!terms);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue((prevState) => ({ ...prevState, [name]: value }));

    if (name === "password") setPasswordStrength(getPasswordStrength(value));
  };

  const getPasswordStrength = (password) => {
    if (
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /\d/.test(password) &&
      /[^A-Za-z0-9]/.test(password)
    ) {
      return "strong";
    } else if (password.length >= 6) {
      return "moderate";
    } else {
      return "weak";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (value.password !== value.confirmPassword) {
      toast.error("Passwords do not match!");
      setLoading(false);
      return;
    }

    if (!terms) {
      toast.warn("Please accept the terms and conditions.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post("https://api.easytaxexperts.com/signUp", {
        username: value.username,
        email: value.email,
        phoneNumber: value.phoneNumber,
        password: value.password,
        terms,
      });

      if (response.status === 200) {
        toast.success("Registration successful. Check your email for details!");
        navigate("/login");
      }
    } catch (error) {
      if (error.response?.status === 409) {
        toast.info("User already registered. Please log in.");
      } else {
        console.error("Error during registration:", error);
        toast.error("Something went wrong. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ete-signup-container">
      <div className="ete-signup-box">
        {/* Left Side Image */}
        <div className="ete-signup-image">
          <img src={ppp} alt="Signup" className="ete-signup-image-content" />
        </div>

        {/* Right Side Form */}
        <div className="ete-signup-content">
          <Link to="/" className="ete-signup-back-link">
            <FaArrowLeft size={14} style={{ marginRight: "8px" }} /> Back to Home
          </Link>

          <h1 className="ete-signup-heading">Create Your Account</h1>

          <form onSubmit={handleSubmit} className="ete-signup-form">
            <div className="ete-signup-field">
              <input
                type="text"
                placeholder="Username"
                name="username"
                value={value.username}
                onChange={handleChange}
                required
              />
            </div>
            <div className="ete-signup-field">
              <input
                type="email"
                placeholder="Email"
                name="email"
                value={value.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="ete-signup-field">
              <input
                type="text"
                placeholder="Phone Number"
                name="phoneNumber"
                value={value.phoneNumber}
                onChange={handleChange}
                required
              />
            </div>
            <div className="ete-signup-field">
              <input
                type="password"
                placeholder="Password"
                name="password"
                value={value.password}
                onChange={handleChange}
                required
              />
            </div>

            <div className="ete-signup-password-strength">
              {passwordStrength && (
                <p
                  style={{
                    color:
                      passwordStrength === "strong"
                        ? "green"
                        : passwordStrength === "moderate"
                        ? "orange"
                        : "red",
                  }}
                >
                  Password strength: {passwordStrength.charAt(0).toUpperCase() +
                    passwordStrength.slice(1)}
                </p>
              )}
            </div>

            <div className="ete-signup-field">
              <input
                type="password"
                placeholder="Confirm Password"
                name="confirmPassword"
                value={value.confirmPassword}
                onChange={handleChange}
                required
              />
            </div>

            <div className="ete-signup-terms">
              <input
                type="checkbox"
                checked={terms}
                onChange={handleTermsChange}
                id="ete-terms"
              />
              <label htmlFor="ete-terms">
                I agree to the{" "}
                <a href="/terms" target="_blank" rel="noopener noreferrer">
                  Terms and Conditions
                </a>
              </label>
            </div>

            <button type="submit" disabled={loading} className="ete-signup-button">
              {loading ? "Signing Up..." : "Sign Up"}
            </button>

            <p className="ete-signup-footer">
              Already have an account?{" "}
              <Link to="/login" className="ete-signup-link">
                Login
              </Link>
            </p>
          </form>

          <ToastContainer />
        </div>
      </div>
    </div>
  );
};

export default Signup;